import React, { PureComponent } from "react";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import TextTruncate from "react-text-truncate";

export const AnalyzeCard = props => {
  const { alert, handleAction } = props;
  let stage = alert.metadata.stage;
  let type = alert.metadata.type;
  let subType = alert.metadata.sub_type;
  let message =
    type == "newsfeed_article"
      ? alert.data
        ? alert.data.title + ": " + alert.data.description
        : ""
      : type == "variable"
      ? `Rule Break: ${alert.data.ruleBreak ? "True" : "False"}`
      : type == "risk_analyzer_engine"
      ? `Buyer Intensity: ${alert.data.buyerIntenstiy}\nSeller Intensity: ${alert.data.sellerIntenstiy}`
      : type == "court_ruling"
      ? alert.data.rulings.length > 0
        ? alert.data.rulings[0]
        : ""
      : "";
  let secTitle =
    type == "risk_analyzer_engine"
      ? alert.data.clause
      : alert.alert_message.split("_").join(" ");

  let showTruncated =
    type == "court_ruling" || type == "newsfeed_article" ? true : false;

  return (
    <div onClick={props.onClick} className={`notification-card`}>
      <div
        className={`notification-card__border ${
          stage == "pulse"
            ? "bg_orange"
            : stage == "playbook"
            ? "bg_red"
            : "bg_blue"
        }`}
      ></div>
      <div className={`notification-card__content`}>
        <h5
          className={`notification-card__title ${
            stage == "pulse"
              ? "orange"
              : stage == "modeling"
              ? "red"
              : stage == "playbook"
              ? "red"
              : "green"
          }`}
        >
          {stage} {type.replace("_", " ").replace("_", " ")}
          <span
            className={`notification-card__type ${
              subType == "risk"
                ? "red"
                : subType == "mixed" || subType == "neutral"
                ? "coffee"
                : subType == "opportunity"
                ? "green"
                : "orange"
            }`}
          >
            {subType.split("_").join(" ")}
          </span>
        </h5>
        <h3 className="notification-card__title">{secTitle}</h3>
        <p className="notification-card__message">
          {showTruncated ? (
            <span>
              {`${message.substring(0, 50)} ${
                message.length > 50 ? "..." : null
              }`}
              {alert && alert.data && alert.data.rulings ? (
                <a
                  onClick={e =>
                    handleAction("view-rulings", alert.data.rulings)
                  }
                >
                  Read
                </a>
              ) : null}
            </span>
          ) : (
            /* <TextTruncate
              line={2}
              element="span"
              truncateText="…"
              text={message}
              textTruncateChild={
                alert && alert.data && alert.data.rulings ? (
                  <a
                    onClick={e =>
                      handleAction("view-rulings", alert.data.rulings)
                    }
                  >
                    Read
                  </a>
                ) : null
              }
            /> */
            message
          )}
        </p>

        <div class="notification-card__footer">
          <span class="footer__text">View Impacted Clauses</span>
          <span
            class={`footer__icon ${
              stage == "pulse"
                ? "bg_orange"
                : stage == "playbook"
                ? "bg_red"
                : "bg_blue"
            }`}
          >
            <ChevronDownIcon />
          </span>
        </div>
      </div>
    </div>
  );
};
